import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { api, errorTreatment } from "../../../../../services/api";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import NumberProps from "../NumberProps";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export const NumbersDayReturns = () => {
  const { id, shortToken , mode } = useParams();
  const { changeVisibility } = useContext(LoadingContext);
  const { hasShortToken} = useContext(AuthContext);
  const { reloadComponent, componentProperty, generateRedirectUrl } = useContext(DashboardContext);
  const [returns, setReturns] = useState<{ count: number }>({ count: 0 });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  let routeReturns: string;

  if (hasShortToken) {
    routeReturns = `/documents?graphic_id=numbersDayReturns&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeReturns = `/documents?graphic_id=numbersDayReturns&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeReturns)
      .then((returns: { data: { count: number } }) => {
        setReturns(returns.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  useEffect(() => {
    if (
      mode === "view" &&
      componentProperty({
        id: "numbersDayReturns",
        property: "redirect",
      })
    ) {
      const number = document.querySelector(
        "#numbers-day-returns .number-item"
      );
      if (number) {
        number.addEventListener("click", async function () {
          window.open(
            await generateRedirectUrl("numbersDayReturns", {
              redirectTowerToIndex: true,
              date: true,
              dueRouteDate: 'dateR',
              status_stop_id: '13,14,21'
            }),
            "_blank"
          );
        });
      }
    }
  }, [completeRequisition]);

  return completeRequisition && !reloadComponent ? (
    <div id="numbers-day-returns" className="w-100">
      <NumberProps
        value={returns}
        title="Devolução"
        id="numbers-day-returns"
        clickable={componentProperty({
          id: "numbersDayReturns",
          property: "redirect",
        })}
        scale={6}
      />
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
